import { render, staticRenderFns } from "./WelcomeBack.vue?vue&type=template&id=0656780b"
import script from "./WelcomeBack.vue?vue&type=script&lang=js"
export * from "./WelcomeBack.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBack.vue?vue&type=style&index=0&id=0656780b&prod&style=scss&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports